import styled from 'styled-components';
export const Wrapper = styled.div `
  aspect-ratio: 200 / 75;
  width: 100%;
  position: relative;
  padding: 1rem;
`;
export const Background = styled.picture `
  position: absolute;
  left: 0;
  top: 0;
  object-fit: cover;
  object-position: center;
  overflow: hidden;
  user-select: none;
  pointer-events: none;
  border-top-left-radius: var(--border-radius-lg);
  border-top-right-radius: var(--border-radius-md);
  width: 100%;
  height: 100%;
`;
export const Icon = styled.img `
  max-width: 4.5rem;
  position: absolute;
  left: 1rem;
  top: 1rem;
  z-index: 2;
`;
export default {
    Wrapper,
    Background,
    Icon,
};
